import { Message, Loading} from 'element-ui'
import zero from '../../mp3/0.mp3';
import one from '../../mp3/1.mp3';
import two from '../../mp3/2.mp3';
import three from '../../mp3/3.mp3';
import four from '../../mp3/4.mp3';
import five from '../../mp3/5.mp3';
import six from '../../mp3/6.mp3';
import seven from '../../mp3/7.mp3';
import eight from '../../mp3/8.mp3';
import nine from '../../mp3/9.mp3';
import ten from '../../mp3/10.mp3';
import hundred from '../../mp3/hundred.mp3';

import badNetwork from '../../mp3/badNetwork.mp3'

import store from '@/store'

var loading;
//封装Loading
var showLoading = function(msg){
	loading = Loading.service({
		lock: true,
		text: msg ? msg : '加载中...',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.5)'
	})
}
var hideLoading = function(){
	loading.close()
	// Loading.service({
	// 	lock: true,
	// 	text: '加载中...',
	// 	spinner: 'el-icon-loading',
	// 	background: 'rgba(0, 0, 0, 0.5)'
	// }).close()
}
//封装message
var messageError = function(msg){
	Message.error(msg)
}
var messageSuccess = function (msg) {
	Message.success(msg)
}
var messageClose = function () {
	Message.closeAll()
}

// 本地存储企业级用户信息
var localUserInfo = {
	setItem: function (data) {
		localStorage.setItem('eUserInfo', JSON.stringify(data))
	},
	getItem: function () {
		return JSON.parse(localStorage.getItem('eUserInfo'))
	},
	removeItem: function () {
		localStorage.removeItem('eUserInfo')
	}
}
/**
 * 本地存储数据 storage
 * sessionStorage  临时存储，在关闭窗口或标签页之后将会删除这些数据
 * localStorage    没有过期时间，直至手动删除
 */
var storage = {
	sessionSetItem: function (key, value) {
		sessionStorage.setItem(key, JSON.stringify(value))
	},
	sessionGetItem: function (key) {
		return JSON.parse(sessionStorage.getItem(key))
	},
	sessionRemoveItem: function (key) {
		sessionStorage.removeItem(key)
	},

	/* 永久存储 */
	localSetItem: function (key, value) {
		localStorage.setItem(key, JSON.stringify(value))
	},
	localGetItem: function (key) {
		return JSON.parse(localStorage.getItem(key))
	},
	localRemoveItem: function (key) {
		localStorage.removeItem(key)
	},
}


//  检查数组是否有重复的数据
function isRepeat(arr){
	var hash = {};
	for (var i in arr) {
		if (hash[arr[i].box_number])
			return true;
		hash[arr[i].box_number] = true;
	}
	return false;
}

// 深拷贝对象
function deepCopy(data) {
	return JSON.parse(JSON.stringify(data))
}

//循环播放语音
function orderMp3(data,callback){
	var mp3Sourse;
	switch(data[0]){
		case '0':
			mp3Sourse = zero
			break;
		case '1':
			mp3Sourse = one
			break;
		case '2':
			mp3Sourse = two
			break;
		case '3':
			mp3Sourse = three
			break;
		case '4':
			mp3Sourse = four
			break;
		case '5':
			mp3Sourse = five
			break;
		case '6':
			mp3Sourse = six
			break;
		case '7':
			mp3Sourse = seven
			break;
		case '8':
			mp3Sourse = eight
			break;
		case '9':
			mp3Sourse = nine
			break;
		case '十':
			mp3Sourse = ten
			break;
		case '百':
			mp3Sourse = hundred
			break;
	}
	var url = mp3Sourse
	var audio = new Audio(url);
	audio.src = url;
	audio.play();
	data = data.substr(1,data.length)
	if(data.length>0){
		audio.addEventListener('ended', function () {
			orderMp3(data,function(){
				callback()
			})
		}, false);
	}else{
		if(typeof callback == 'function'){
			setTimeout(function(){
				callback()
			},1000)
		}
	}
}

//获取语音
function getMp3(data,callback){
	var arr = data.split('')
	if(arr.length == 3){
		arr.splice(1,0,'百')
		if(arr[arr.length-2] == '0' && arr[arr.length-1] == '0'){
			arr.splice(-2,2)
		}else if(arr[arr.length-2] != '0' && arr[arr.length-1] == '0'){
			arr.splice(3,0,'十')
			arr.splice(-1,1)
		}else if(arr[arr.length-2] != '0' && arr[arr.length-1] != '0'){
			arr.splice(3,0,'十')
		}
	}else if(arr.length == 2){
		if(arr[0] != '0'){
			arr.splice(1,0,'十')
			if(arr[arr.length-1] == '0'){
				arr.splice(-1,1)
			}
		}
	}
	arr = arr.join('')
	if(typeof callback == 'function'){
		orderMp3(arr,function(){
			callback()
		})
	}
}

function text2Audio(data){
	// var text = encodeURI(data)
	// var token = sessionStorage.getItem('acceToken')
	// var url = 'http://tsn.baidu.com/text2audio?lan=zh&ctp=1&cuid='+config.deviceId+'&tok='+token+'&vol=10&spd=5&per=0&tex=' + text;
	// var audio = new Audio(url);
	// audio.src = url;
	// audio.play();
}

//打印日志
function conLog(title,data){
	console.log(title,data ? data :'')
}

//无网络语音提示
function checkOnLine(){
	messageError('网络信号不良，请稍后再试')
	var url = badNetwork
	var audio = new Audio(url);
	audio.src = url;
	audio.play();
}

/**
 * 倒计时公共函数
 * countDown 倒计时
 * clearCountDown 清除倒计时
 */

var interval
function countDown(func) {
	interval = window.setInterval(function () {
		func()
	}, 1000)
}

var clearCountDown = function () {
	clearInterval(interval)
	// interval = null
	// console.log('清除成功', '')
}

//超时
var overtimeStatus = '';
function overTime(callback){
	var _wait = store.state.overTime
	if(_wait == 0) {
		clearTimeout(overtimeStatus)
		if(typeof callback == 'function'){
			callback()
		}
	} else {
		_wait--;
		store.state.overTime = _wait
		overtimeStatus = setTimeout(function() {
			overTime(callback);
		},1000);
	}
}

export {
	messageError,
	messageSuccess,
	messageClose,
	showLoading,
	hideLoading,
	localUserInfo,
	storage,
	isRepeat,
	deepCopy,
	text2Audio,
	conLog,
	getMp3,
	orderMp3,
	checkOnLine,
	countDown,
	clearCountDown,
	overtimeStatus,
	overTime,
}


//////////////////
// WEBPACK FOOTER
// ./static/js/utils/utility.js
// module id = OL8I
// module chunks = 1